"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decimal = exports.u512 = exports.u256 = exports.u128 = exports.u64 = exports.bigInt = exports.publicKey = exports.bool = exports.encodeDecode = void 0;
const web3_js_1 = require("@solana/web3.js");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const buffer_layout_1 = require("buffer-layout");
const bigint_buffer_1 = require("bigint-buffer");
const constants_1 = require("../constants");
/** @internal */
const encodeDecode = (layout) => {
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return { decode, encode };
};
exports.encodeDecode = encodeDecode;
/** @internal */
const bool = (property = 'bool') => {
    const layout = (0, buffer_layout_1.u8)(property);
    const { encode, decode } = (0, exports.encodeDecode)(layout);
    const boolLayout = layout;
    boolLayout.decode = (buffer, offset) => {
        const src = decode(buffer, offset);
        return !!src;
    };
    boolLayout.encode = (bool, buffer, offset) => {
        const src = Number(bool);
        return encode(src, buffer, offset);
    };
    return boolLayout;
};
exports.bool = bool;
/** @internal */
const publicKey = (property = 'publicKey') => {
    const layout = (0, buffer_layout_1.blob)(32, property);
    const { encode, decode } = (0, exports.encodeDecode)(layout);
    const publicKeyLayout = layout;
    publicKeyLayout.decode = (buffer, offset) => {
        const src = decode(buffer, offset);
        return new web3_js_1.PublicKey(src);
    };
    publicKeyLayout.encode = (publicKey, buffer, offset) => {
        const src = publicKey.toBuffer();
        return encode(src, buffer, offset);
    };
    return publicKeyLayout;
};
exports.publicKey = publicKey;
/** @internal */
const bigInt = (length) => (property = 'bigInt') => {
    const layout = (0, buffer_layout_1.blob)(length, property);
    const { encode, decode } = (0, exports.encodeDecode)(layout);
    const bigIntLayout = layout;
    bigIntLayout.decode = (buffer, offset) => {
        const src = decode(buffer, offset);
        return (0, bigint_buffer_1.toBigIntLE)(src);
    };
    bigIntLayout.encode = (bigInt, buffer, offset) => {
        const src = (0, bigint_buffer_1.toBufferLE)(bigInt, length);
        return encode(src, buffer, offset);
    };
    return bigIntLayout;
};
exports.bigInt = bigInt;
/** @internal */
exports.u64 = (0, exports.bigInt)(8);
/** @internal */
exports.u128 = (0, exports.bigInt)(16);
exports.u256 = (0, exports.bigInt)(8 * 4);
exports.u512 = (0, exports.bigInt)(8 * 8);
/** @internal */
const decimal = (property = 'decimal') => {
    const layout = (0, exports.u128)(property);
    const { encode, decode } = (0, exports.encodeDecode)(layout);
    const decimalLayout = layout;
    decimalLayout.decode = (buffer, offset) => {
        const src = decode(buffer, offset).toString();
        return new bignumber_js_1.default(src).div(constants_1.WAD);
    };
    decimalLayout.encode = (decimal, buffer, offset) => {
        const src = BigInt(decimal.times(constants_1.WAD).integerValue().toString());
        return encode(src, buffer, offset);
    };
    return decimalLayout;
};
exports.decimal = decimal;
